class CAlert {
    constructor(c = {}) {
        this.parent = c.parent
        this.trigger = c.trigger
        this.init()
    }
    init() {
        this.listenerTriggerClick()
    }
    listenerTriggerClick() {
        this.trigger.addEventListener('click', e => {
            this.handlerTrigerClick()
        })
    }
    handlerTrigerClick() {
        this.parent.remove()
    }
}

let allAlertParent = document.querySelectorAll('[data-alert-parent]')
let allAlertCloseTrigger = document.querySelectorAll('[data-alert-close]')

if (
    allAlertParent.length ===
    allAlertCloseTrigger.length
) {
    for (let i = 0; i < allAlertParent.length; i++) {
        new CAlert({
            parent: allAlertParent[i],
            trigger: allAlertCloseTrigger[i]
        })
    }
}